<template>
  <section class="about" id="about">
    <div class="container">
      <div class="about-grid">
        <!-- 左：图片 -->
        <div class="about-media">
          <img class="about-img" :src="img" alt="技明电器制造现场" />
          <div class="about-badge">
            <div class="badge-num">2009</div>
            <div class="badge-text">公司成立年份</div>
          </div>
        </div>

        <!-- 右：文案 -->
        <div class="about-body">
          <div class="sec-label">关于技明</div>
          <h3 class="sec-title">一家扎根制造、立足全球的电器企业</h3>
          <p class="sec-text">
            余姚市技明电器有限公司成立于 2009 年，坐落于浙江省余姚市凤山街道永丰村，深耕家用电器、照明灯具、塑料制品、五金件四大品类的制造与加工。公司同时拥有自营与代理进出口业务，帮助国内外客户高效对接优质供应链，让中国制造走向更广阔的市场。
          </p>

          <div class="adv-list">
            <div v-for="(a, i) in advantages" :key="i" class="adv-item">
              <span class="adv-ico" aria-hidden="true">{{ a.icon }}</span>
              <div>
                <div class="adv-title">{{ a.title }}</div>
                <div class="adv-desc">{{ a.desc }}</div>
              </div>
            </div>
          </div>

          <div class="about-actions">
            <button class="btn btn-solid" type="button" @click="$router.push('/AboutUs')">了解更多</button>
            <button class="btn btn-outline" type="button" @click="$router.push('/CustomerCases')">客户案例</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const img = require("../static/6.webp");

const advantages = [
  { icon: "🏭", title: "全品类制造", desc: "家电 / 照明 / 塑料 / 五金，一站式制造加工能力" },
  { icon: "🌐", title: "进出口服务", desc: "自营 + 代理贸易，链接国内外优质市场资源" },
  { icon: "⚙️", title: "灵活定制", desc: "支持 OEM / ODM 与多元化定制生产需求" },
  { icon: "🤝", title: "稳定交付", desc: "成熟产线与品质管控，确保交期稳定可靠" },
];
</script>

<style scoped>
.about {
  padding: 92px 0;
  background: #fff;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

.about-grid {
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 60px;
  align-items: center;
}

/* 图片区 */
.about-media {
  position: relative;
}

.about-img {
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(16, 42, 67, 0.16);
  display: block;
}

.about-badge {
  position: absolute;
  right: -18px;
  bottom: -22px;
  background: linear-gradient(135deg, #0b66bb, #0a4f97);
  color: #fff;
  border-radius: 16px;
  padding: 18px 26px;
  text-align: center;
  box-shadow: 0 16px 36px rgba(10, 79, 151, 0.35);
}

.badge-num {
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  color: #ffc53d;
}

.badge-text {
  margin-top: 6px;
  font-size: 12.5px;
  letter-spacing: 1px;
}

/* 文案区 */
.sec-label {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 999px;
  background: #e8f1fc;
  color: #0a4f97;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 16px;
}

.sec-title {
  font-size: 32px;
  line-height: 1.4;
  font-weight: 800;
  color: #102a43;
  margin: 0 0 20px;
}

.sec-text {
  font-size: 15px;
  line-height: 1.9;
  color: #5b6b7e;
  margin: 0 0 28px;
}

.adv-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 32px;
}

.adv-item {
  display: flex;
  gap: 12px;
  padding: 16px;
  border-radius: 14px;
  background: #f6f9fd;
  border: 1px solid #edf2f9;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.adv-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(10, 79, 151, 0.1);
}

.adv-ico {
  font-size: 22px;
  flex: 0 0 auto;
}

.adv-title {
  font-size: 15px;
  font-weight: 800;
  color: #102a43;
}

.adv-desc {
  margin-top: 5px;
  font-size: 12.5px;
  line-height: 1.6;
  color: #7b8a9c;
}

/* 按钮 */
.btn {
  height: 46px;
  padding: 0 30px;
  border-radius: 999px;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-solid {
  background: linear-gradient(135deg, #0b66bb, #0a4f97);
  color: #fff;
  box-shadow: 0 10px 24px rgba(10, 79, 151, 0.28);
}

.btn-outline {
  background: #fff;
  color: #0a4f97;
  border: 1.5px solid #bcd6f2;
}

.btn:hover {
  transform: translateY(-2px);
}

.about-actions {
  display: flex;
  gap: 12px;
}

@media (max-width: 960px) {
  .about-grid {
    grid-template-columns: 1fr;
    gap: 46px;
  }

  .about-media {
    max-width: 560px;
  }

  .sec-title {
    font-size: 26px;
  }

  .adv-list {
    grid-template-columns: 1fr;
  }
}
</style>
